import { Route } from '@angular/router';

import { EditAccountInfoComponent } from './edit-account-info.component';

export const editAccountInfoRoute: Route = {
    path: 'modificaInformazioni',
    component: EditAccountInfoComponent,
    data: {
        pageTitle: 'pagetitles.editaccountinfo'
    }
};
